import { isDealerVehicle } from "./isDealerVehicle";

export const SELLER_SCOPE = Object.freeze({
  CUSTOMER: "customer",
  DEALER: "dealer",
  ALL: "all",
});

export function normalizeSellerScope(value) {
  if (value === SELLER_SCOPE.CUSTOMER || value === SELLER_SCOPE.DEALER) {
    return value;
  }

  return SELLER_SCOPE.ALL;
}

export function matchesSellerScope(vehicle, value) {
  const scope = normalizeSellerScope(value);

  if (scope === SELLER_SCOPE.ALL) return true;

  const dealerVehicle = isDealerVehicle(vehicle);
  return scope === SELLER_SCOPE.DEALER ? dealerVehicle : !dealerVehicle;
}

export function getSellerScopeTag(value) {
  const scope = normalizeSellerScope(value);

  if (scope === SELLER_SCOPE.CUSTOMER) return "Nur Kunden";
  if (scope === SELLER_SCOPE.DEALER) return "Nur Händler";
  return null;
}
